
import * as z from "zod";

export const signupFormSchema = z.object({
  email: z.string().email({ message: "Please enter a valid email address" }),
  password: z.string().min(8, { message: "Password must be at least 8 characters long" }),
  ageRange: z.string({ required_error: "Please select your age range" }),
  educationLevel: z.string({ required_error: "Please select your education level" }),
  country: z.string({ required_error: "Please select your country" }).default("United States"),
});

export type SignupFormValues = z.infer<typeof signupFormSchema>;
